import { tw } from "@careinfo/tailwind";
import { BubbleMenu as BaseBubbleMenu } from "@tiptap/react";
import React, { memo, useCallback } from "react";
import { MenuProps, ShouldShowProps } from "../../../../components/menus/types";
import { Icon } from "../../../../components/ui/Icon";
import * as PopoverMenu from "../../../../components/ui/PopoverMenu";
import { Toolbar } from "../../../../components/ui/Toolbar";
import { isRowGripSelected } from "./utils";

const MemoButton = memo(Toolbar.Button);

export const TableRowMenu = React.memo(
  ({ editor, appendTo }: MenuProps): JSX.Element => {
    const shouldShow = useCallback(
      ({ view, state, from }: ShouldShowProps) => {
        if (!state || !from) {
          return false;
        }

        return isRowGripSelected({ editor, view, state, from });
      },
      [editor]
    );

    const onAddRowBefore = useCallback(() => {
      editor.chain().focus().addRowBefore().run();
    }, [editor]);

    const onAddRowAfter = useCallback(() => {
      editor.chain().focus().addRowAfter().run();
    }, [editor]);

    const onDeleteRow = useCallback(() => {
      editor.chain().focus().deleteRow().run();
    }, [editor]);

    return (
      <BaseBubbleMenu
        editor={editor}
        pluginKey="tableRowMenu"
        updateDelay={0}
        tippyOptions={{
          appendTo: () => {
            return appendTo?.current;
          },
          placement: "left",
          offset: [0, 15],
          popperOptions: {
            modifiers: [{ name: "flip", enabled: false }],
          },
        }}
        shouldShow={shouldShow}
      >
        <Toolbar.Wrapper isVertical>
          <MemoButton
            tooltipShortcut={["Mod", "B"]}
            onClick={onAddRowBefore}
            active={false}
          >
            <span className={tw`w-full flex items-center justify-between`}>
              <Icon name="ArrowUpToLine" />
              <span>Add row before</span>
            </span>
          </MemoButton>
          <MemoButton
            tooltipShortcut={["Mod", "B"]}
            onClick={onAddRowAfter}
            active={false}
          >
            <span className={tw`w-full flex items-center justify-between`}>
              <Icon name="ArrowDownToLine" />
              <span>Add row after</span>
            </span>
          </MemoButton>
          <MemoButton
            tooltipShortcut={["Mod", "B"]}
            onClick={onDeleteRow}
            active={false}
          >
            <span className={tw`w-full flex items-center justify-between`}>
              <Icon name="Trash" />
              <span>Delete row</span>
            </span>
          </MemoButton>
        </Toolbar.Wrapper>
      </BaseBubbleMenu>
    );
  }
);

TableRowMenu.displayName = "TableRowMenu";

export default TableRowMenu;
